// extracted by mini-css-extract-plugin
export default {"container":"aq-z","ratingLayout":"bq-z","ratingLabel":"cq-z","nonInteractiveRatingLabel":"dq-z"};